export default __webpack_public_path__ + "static/media/bitcoin.a3808ec1.svg";